import api from './api';

class AdminLeagueService {
  async loadLeagues(deactivated = false) {
    return await api
      .get(`/admin/league?deactivated=${deactivated}`)
      .then(async (response) => {
        return response.data.leagues;
      });
  }

  async createLeague(
    name,
    min_deck,
    max_deck,
    min_safe,
    max_safe,
    coins_rewards,
    gems_rewards,
    bud_reward,
    start_color,
    end_color,
    background,
    business_uuid,
    start_day,
    start_hour,
    end_day,
    end_hour,
    view_order,
    auto_update_bud,
    launch_date,
    close_date,
    board,
    logo,
    previous_league,
    game_rule,
  ) {
    const body = {
      name, min_deck, max_deck, min_safe, max_safe,
      coins_rewards, gems_rewards, bud_reward, start_color, end_color,
      background, business_uuid, start_day, start_hour, end_day, end_hour,
    }
    if (view_order !== undefined && view_order !== null) body.view_order = view_order
    if (auto_update_bud !== undefined) body.auto_update_bud = auto_update_bud
    if (launch_date) body.launch_date = launch_date
    if (close_date) body.close_date = close_date
    if (board) body.board = board
    if (logo) body.logo = logo
    if (previous_league) body.previous_league = previous_league
    if (game_rule !== undefined && game_rule !== null) body.game_rule = game_rule
    return await api
      .post(`/admin/league/create`, body)
      .then(async (response) => {
        return response.data.league_uuid;
      });
  }

  async createLeagueQuest(
    title,
    league_uuid,
    nb_victory,
    bud_uuid,
    nb_coins,
    nb_gems,
    irl_reward,
  ) {
    return await api
      .post(`/admin/league/quest`, {
        title,
        league_uuid,
        nb_victory,
        bud_uuid,
        nb_coins,
        nb_gems,
        irl_reward,
      })
      .then(async (response) => {
        return response.data.status;
      });
  }

  async activateLeague(league_uuid) {
    return await api
      .post(`/admin/league/reactivate`, {league_uuid})
      .then(async (response) => {
        return response.data.status;
      });
  }

  async deactivateLeague(league_uuid) {
    return await api
      .post(`/admin/league/deactivate`, {league_uuid})
      .then(async (response) => {
        return response.data.status;
      });
  }

  async updateBudLeagueReward(league_uuid, bud_reward) {
    return await api
      .post(`/admin/league/${league_uuid}`, {bud_reward})
      .then(async (response) => {
        return response.data.status;
      });
  }

  async updateLeagueBackground(league_uuid, background) {
    return await api
      .post(`/admin/league/${league_uuid}`, {background})
      .then(async (response) => {
        return response.data.status;
      });
  }

  async updateQuest(updateData) {
    return await api
      .post(`/admin/league/quest/update`, updateData)
      .then(async (response) => {
        return response.data.status;
      });
  }

  async updateLeague(league_uuid, updateData) {
    return await api
      .post(`/admin/league/${league_uuid}`, updateData)
      .then(async (response) => {
        return response.data.status;
      });
  }
}
// eslint-disable-next-line
export default new AdminLeagueService();